import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Внесение комментария",
    loading: _ctx.isLoading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.rejection_reason_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.rejection_reason_id) = $event)),
        "is-invalid": _ctx.state_form$.rejection_reason_id.$error,
        "validation-errors": _ctx.state_form$.rejection_reason_id.$errors,
        options: _ctx.REJECTION_REASONS,
        class: "mt-2"
      }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
      _createVNode(_component_the_textarea, {
        value: _ctx.state.rejection_comment,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.rejection_comment) = $event)),
        "is-invalid": _ctx.state_form$.rejection_comment.$error,
        "validation-errors": _ctx.state_form$.rejection_comment.$errors,
        class: "w-full",
        placeholder: "Комментарий",
        rows: 5,
        autoheight: ""
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}